import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ValidationService } from 'src/app/data/service/validation.service';
import { GdnnService } from 'src/app/data/service/gdnn.service';


@Component({
    selector: 'app-vnptpay',
    templateUrl: './vnptpay.component.html',
    styleUrls: ['./vnptpay.component.scss']
})
export class VnptpayComponent implements OnInit {

    public vnptpayResponseCode: string;
    public data: string;
    public secureCode: string;
    public message: string = '';
    private messageList: any[] = 
    [
        { id: '00', name: 'Giao dịch thành công' },
        { id: '02', name: 'Thông tin giao dịch không đúng hoặc bị thay đổi' },
        { id: '04', name: 'Giao dịch thất bại do vượt quá thời gian cho phép' },
        { id: '16', name: 'Giao dịch nghi ngờ, đang chờ xử lý' },
        { id: '17', name: 'Thông tin thẻ hoặc tài khoản không đúng' },
        { id: '19', name: 'Thẻ/Tài khoản bị khóa hoặc chưa đăng ký internet banking' },
        { id: '20', name: 'Số dư không đủ để thực hiện giao dịch' },
        { id: '22', name: 'Sai OTP, hết thời gian nhập OTP hoặc vượt quá số lần cho phép' },
        { id: '65', name: 'Lỗi hạn mức giao dịch tối đa hoặc tối thiểu' },
        { id: '70', name: 'Khách hàng hủy giao dịch' },
        { id: '97', name: 'Hệ thống ngân hàng lỗi hoặc không phản hồi' },
    ]

    constructor(
        private _location: Location, 
        private route: ActivatedRoute, 
        private router: Router,
        private service: GdnnService) {
        this.route.queryParams.subscribe(res => {
            if (res && !ValidationService.isBlank(res["vnptpayResponseCode"])
            && !ValidationService.isBlank(res["data"])
            && !ValidationService.isBlank(res["secureCode"])) {
                this.vnptpayResponseCode = res["vnptpayResponseCode"];
                this.data = res["data"];
                this.secureCode = res["secureCode"];
                this.message = this.convertCodeToMessage(this.vnptpayResponseCode);
            } else {
                this.router.navigate(['error', 'page-not-found']);
            }
        })
    }

    ngOnInit(): void {
        if (this.vnptpayResponseCode == "00") {
            var body = {
                merchantOrderID: this.data,
                secureCode: this.secureCode
            }
            this.service.updateModulesStatus(body).subscribe(() => {

            }, () => {

            })
        }
    }

    goBack() {
        // this._location.back();
        this.router.navigate(["gdnn", "phi-dao-tao"], { queryParams: { back: true }});
    }

    convertCodeToMessage(statusCode: string) {
        var mess = this.messageList.filter(p => p.id == statusCode);
        return mess.length > 0 ? mess[0].name : 'Lỗi không xác định';
    }

}
